import React from 'react';
import Icon from '../shared/Icon.tsx';
import {LanguagesIcon} from 'lucide-react';

interface FloatingTranslationButtonProps {
    onClick: () => void;
}

// Compact tab hugging the left screen edge (so it stays clear of tab content
// like the Blocks toolbox). The "Translate" label slides out on hover/focus.
const FloatingTranslationButton: React.FC<FloatingTranslationButtonProps> = ({
    onClick
}) => {
    return (
        <button
            type="button"
            className="floating-translate-btn"
            onClick={onClick}
            title="Translate this page with AI"
            aria-label="Translate this page with AI"
        >
            <Icon icon={LanguagesIcon} />
            <span className="floating-translate-btn__label">Translate</span>
        </button>
    );
};

export default FloatingTranslationButton;
